import React, { useState, useEffect } from "react";
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next';

import "../buttons/primary-button.css"
import "./search-bar.css";

const SearchBar = ({ initialQuery, onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { language } = useI18next();
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  useEffect(() => {
    setSearchQuery(initialQuery || "");
  }, [initialQuery]);

  return (
    <div className="search">
      <form id="search" className="search-form" onSubmit={handleSubmit}>
        <input
          type="text"
          className="search-text-input border"
          placeholder={ t('search.placeholder', { lng: language }) }
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button form="search" type="submit" className="primary-button primary-button-blue ms-3">
          { t('search.search', { lng: language }) }
        </button>
      </form>
    </div>
  );
};

export default SearchBar;
